import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_type",
  ref: "addModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  id: "kt_modal_add_type_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Add Program Organization"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_add_type_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_type_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_type_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_type_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-7" }, null, -1)
const _hoisted_8 = { class: "fv-row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Program Organization"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Type Name"
  })
], -1)
const _hoisted_10 = { class: "modal-footer flex-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_add_type_cancel",
  class: "btn btn-light me-3"
}, " Discard ", -1)
const _hoisted_12 = ["data-kt-indicator"]
const _hoisted_13 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_14 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_15 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createTextVNode(" Submit "),
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}